<div class="scanner-insights-main">
  <div class="scanner-insights-lhs">
    <div class="scanner-mosaic-header">
      {{ auth.getScoreName().name + ' Events' }}
    </div>

    <div class="scanner-mosaic-contents">
      <div class="company-block" *ngIf="isSentiment">
        <div class="company-menu">
          <div class="treemap-item">
            <div class="item-bar">
              <div class="item-bar-cont">
                <div class="bar-header">
                  <div class="bar-name">Sentiment</div>
                  <div class="bar-number">
                    <ng-container
                      *ngIf="
                        (scoreLoading$ | async) === false;
                        else scoreLoadingSpinner
                      "
                    >
                      <span class="bar-count">{{
                        (mosaicScore$ | async)?.displayValue
                      }}</span>
                    </ng-container>
                    <ng-template #scoreLoadingSpinner>
                      <mat-spinner [diameter]="16"></mat-spinner>
                    </ng-template>
                  </div>
                </div>
                <div class="bar-cont">
                  <mat-progress-bar
                    class="bar-main"
                    [class.score-pos-light]="routing.theme === 'light'"
                    [class.score-pos-dark]="routing.theme !== 'light'"
                    mode="determinate"
                    [value]="100 - ((mosaicScore$ | async)?.value || 0)"
                  ></mat-progress-bar>
                </div>
                <div class="table-header">
                  <div>Events</div>
                  <div>No. Articles</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="company-treemap"
          *ngIf="loadingState.ready; else loadingEvents"
        >
          <ng-container
            *ngFor="let item of events | orderBy: '-count' | slice: 0 : 5"
          >
            <div
              class="treemap-item"
              [class.mobile]="(screenSize$ | async)?.isMobile"
              *ngIf="item.count > 0"
              (click)="onEventClick(item)"
            >
              <div
                class="item-bar"
                [class.active]="currentParams['eventid'] === item.event.id"
              >
                <div class="item-bar-cont">
                  <div class="bar-header">
                    <div class="bar-name">{{ item.event.name }}</div>
                    <div class="bar-number">
                      <span class="bar-count">{{ item.count }}</span>
                    </div>
                  </div>
                  <div class="bar-cont">
                    <mat-progress-bar
                      class="bar-main"
                      mode="determinate"
                      [value]="calculateBarPercentage(events, item.count)"
                    ></mat-progress-bar>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="events.length === 0" class="noevent">NO EVENTS</div>
        </div>
        <ng-template #loadingEvents>
          <div class="loading" *ngIf="loadingState.loading">
            <mat-spinner [diameter]="50"></mat-spinner>
          </div>
          <div class="nodata" *ngIf="loadingState.noData">
            NO DATA AVAILABLE
          </div>
        </ng-template>
      </div>

      <div class="company-block" *ngIf="!isSentiment">
        <div class="company-menu">
          <div class="treemap-item">
            <div class="item-bar">
              <div class="item-bar-cont">
                <div class="bar-header">
                  <div class="bar-name">
                    {{ auth.getScoreName().name + ' Score' }}
                  </div>
                  <div class="bar-number">
                    <ng-container
                      *ngIf="
                        (scoreLoading$ | async) === false;
                        else scoreLabLoadingSpinner
                      "
                    >
                      <span class="bar-count">{{
                        (mosaicScore$ | async)?.displayValue
                      }}</span>
                    </ng-container>
                    <ng-template #scoreLabLoadingSpinner>
                      <mat-spinner [diameter]="16"></mat-spinner>
                    </ng-template>
                  </div>
                </div>
                <div class="bar-cont">
                  <mat-progress-bar
                    class="bar-main"
                    [class.score-pos-light]="
                      auth.getScoreType() === 'pos' && routing.theme === 'light'
                    "
                    [class.score-pos-dark]="
                      auth.getScoreType() === 'pos' && routing.theme !== 'light'
                    "
                    [class.score-neg]="auth.getScoreType() === 'neg'"
                    mode="determinate"
                    [value]="100 - ((mosaicScore$ | async)?.value || 0) * 10"
                  ></mat-progress-bar>
                </div>
                <div class="table-header">
                  <div>Events</div>
                  <div>No. Articles</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="company-treemap"
          *ngIf="loadingState.ready; else loadingScoreEvents"
        >
          <ng-container
            *ngFor="
              let item of scoreEvents
                | orderBy: '-contrib_amount'
                | slice: 0 : 5
            "
          >
            <div
              class="treemap-item"
              [class.mobile]="(screenSize$ | async)?.isMobile"
              *ngIf="item.contrib_amount > 0"
              (click)="onScoreEventClick(item)"
              id="scanner-insights-event"
            >
              <div
                class="item-bar"
                [class.active]="currentParams['eventid'] === item.id"
              >
                <div class="item-bar-cont">
                  <div class="bar-header">
                    <div class="bar-name">{{ item.name }}</div>
                    <div class="bar-number">
                      <span class="bar-count">{{ item.contrib_amount }}</span>
                    </div>
                  </div>
                  <div class="bar-cont">
                    <mat-progress-bar
                      class="bar-main"
                      mode="determinate"
                      [value]="
                        calculateScoreBarPercentage(
                          scoreEvents,
                          item.contrib_amount
                        )
                      "
                    ></mat-progress-bar>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="scoreEvents.length === 0" class="noevent">NO EVENTS</div>
        </div>
        <ng-template #loadingScoreEvents>
          <div class="loading" *ngIf="loadingState.loading">
            <mat-spinner [diameter]="50"></mat-spinner>
          </div>
          <div class="nodata" *ngIf="loadingState.noData">
            NO DATA AVAILABLE
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="scanner-insights-rhs">
    <div class="scanner-chart-header">
      {{ auth.getScoreName().name + ' Trend' }}
    </div>

    <div class="scanner-chart-contents">
      <app-scanner-chart></app-scanner-chart>
    </div>
  </div>
</div>
